import { IApplicationState } from '../../types/redux';

export const selectIsFavorite = (state: IApplicationState): boolean => {
  return state.favorite.isFavorite;
};
